export const SHOP_PIPELINE_AS_OF_PREFIX = 'As of';
export const SHOP_PIPELINE_AS_OF_FALLBACK = 'Live shop pipeline';

export const SHOP_PIPELINE_EMPTY_TEXT = 'No active loans';

export const SHOP_PIPELINE_ALL_LOAN_OFFICERS = 'All loan officers';
export const SHOP_PIPELINE_ALL_MILESTONES = 'All milestones';

export const SHOP_PIPELINE_PII_NOTE = 'Borrower last name + loan last-4 only';

// Rescope (DEV-4041): a company-level (non-broker) user sees whole-company data,
// so the broker "shop" framing is reworded to company-level wording.
export const SHOP_PIPELINE_BROKER_TITLE = 'Shop pipeline';
export const SHOP_PIPELINE_COMPANY_TITLE = 'Company pipeline';
export const SHOP_PIPELINE_BROKER_SUBTITLE = 'Active loans across your shop';
export const SHOP_PIPELINE_COMPANY_SUBTITLE = 'Active loans across the company';
